import { createSvgIcon } from '@automata/mui-theme';
export const AspirateIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path d="M61.9668 36.2297L47.8247 50.3719L45.7034 48.2505L59.8455 34.1084L61.9668 36.2297Z" />
    <path d="M59.8579 34.1086L74.0001 48.2508L71.8788 50.3721L57.7366 36.2299L59.8579 34.1086Z" />
    <path d="M58.3518 37.8916H61.3518V65.8916H58.3518V37.8916Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.969 56.1975C31.7132 57.2015 30.2868 57.2015 30.031 56.1975L22 24.6835H40L31.969 56.1975ZM31 47.8516L36.1396 27.6835L25.8604 27.6835L31 47.8516Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 15H37V24.6105H25V15ZM22 12H40V24.6835H22V12Z"
    />
    <path d="M39 75.1385C39 80.0326 35.4183 84 31 84C26.5817 84 23 80.0326 23 75.1385C23 68.8484 31 60 31 60C31 60 39 68.8484 39 75.1385Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31 81C33.4801 81 36 78.6717 36 75.1385C36 74.1516 35.6721 72.8544 35.0016 71.322C34.3456 69.8227 33.4456 68.2864 32.5043 66.8752C31.9915 66.1065 31.4771 65.3906 31 64.756C30.5229 65.3906 30.0085 66.1065 29.4957 66.8752C28.5544 68.2864 27.6544 69.8227 26.9984 71.322C26.3279 72.8544 26 74.1516 26 75.1385C26 78.6717 28.5199 81 31 81ZM29.0662 62.3451C26.6987 65.4018 23 70.8615 23 75.1385C23 80.0326 26.5817 84 31 84C35.4183 84 39 80.0326 39 75.1385C39 70.8615 35.3013 65.4018 32.9338 62.3451C31.8194 60.9064 31 60 31 60C31 60 30.1806 60.9064 29.0662 62.3451Z"
    />
  </svg>,
  'AspirateIcon'
);
